import { UnitOfMeasurement } from "../../../GeneratedGraphQL";

type CalculateOrganisationProximityOpts = {
  unitOfMeasurement?: UnitOfMeasurement;
};

type Coordinates = {
  latitude: number;
  longitude: number;
};

const toRad = function (num: number) {
  return (num * Math.PI) / 180;
};

/**
 * Calculate the distance between the searched location
 * and an organisation using the Haversine formula.
 */
export const calculateOrganisationProximity = (
  searchedCoordinates: Coordinates,
  organisationCoordinates: Coordinates,
  options?: CalculateOrganisationProximityOpts,
): number => {
  const unitOfMeasurement =
    options?.unitOfMeasurement ?? UnitOfMeasurement.Miles;

  const kilometres = 6371;
  const miles = 3960;

  const radius =
    unitOfMeasurement === UnitOfMeasurement.Miles ? miles : kilometres;

  const dLat = toRad(
    organisationCoordinates.latitude - searchedCoordinates.latitude,
  );
  const dLon = toRad(
    organisationCoordinates.longitude - searchedCoordinates.longitude,
  );
  const lat1 = toRad(searchedCoordinates.latitude);
  const lat2 = toRad(organisationCoordinates.latitude);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return radius * c;
};
